import React, { useEffect, useRef } from "react";
import "./Testimonials.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import ReactStars from "react-rating-stars-component";

const Testimonials = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("active");
        } else {
          sectionRef.current.classList.remove("active");
        }
      },
      {
        threshold: 0.4,
      },
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  const ratingChanged = (newRating) => {
    console.log(newRating);
  };
  const testimonialsCard = [
    {
      id: 1,
      text1: "Audio Meet makes hosting conversations effortless.",
      text2:
        " The host controls are smooth, and managing speakers is incredibly easy—even during live sessions.",
      author: "Oshin",
    },
    {
      id: 2,
      text1: "Audio Meet makes hosting conversations effortless.",
      text2:
        " The host controls are smooth, and managing speakers is incredibly easy—even during live sessions.",
      author: "Rahul",
    },
    {
      id: 3,
      text1: "Audio Meet makes hosting conversations effortless.",
      text2:
        " The host controls are smooth, and managing speakers is incredibly easy—even during live sessions.",
      author: "Sneha",
    },
  ];
  return (
    <section className="testimonials">
      <div className="container">
        <div className="testimonial_holder" ref={sectionRef}>
          <div className="testimonials_header_holder ">
            <img
              src="/assets/images/home/testimonials/testimonials.png"
              alt="testimonial"
              className="testimonial_img scroll_animated_title"
            />
          </div>
          <div className="testimonial_content_holder">
            <div className="row mt-5 align-items-center">
              <div className="col-lg-3 col-md-3 col-sm-3">
                <div className="quote_img_holder">
                  <img
                    src="/assets/images/home/testimonials/quote-1.png"
                    alt="quote"
                    className="quote_img"
                  />
                </div>
              </div>

              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="testimonial_swiper_wrapper">
                  <Swiper
                    modules={[Navigation]}
                    slidesPerView={1}
                    loop={true}
                    speed={700}
                    navigation={{
                      prevEl: ".nav_btn.prev",
                      nextEl: ".nav_btn.next",
                    }}
                  >
                    {testimonialsCard.map((item) => (
                      <SwiperSlide key={item.id}>
                        <div className="testimonial_card">
                          <p className="testimonial_text">
                            {item.text1}{" "}
                            <span className="text_span">{item.text2}</span>
                          </p>

                          <div className="rating-history-stars-container">
                            <div className="rating-history-stars-box">
                              <ReactStars
                                count={5}
                                onChange={ratingChanged}
                                size={24}
                                activeColor="#ffd700"
                              />
                            </div>
                          </div>

                          <p className="testimonial_author">{item.author}</p>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {/* Navigation */}
                  <button className="nav_btn prev">
                    <FontAwesomeIcon icon={faChevronLeft} />
                  </button>
                  <button className="nav_btn next">
                    <FontAwesomeIcon icon={faChevronRight} />
                  </button>
                </div>
              </div>

              <div className="col-lg-3 col-md-3 col-sm-3">
                <div className="quote_img_holder">
                  <img
                    src="/assets/images/home/testimonials/quote-2.png"
                    alt="quote"
                    className="quote_img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
